var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('query-filter',{attrs:{"fields":_vm.fields},scopedSlots:_vm._u([{key:"dateRange",fn:function(ref){
var value = ref.value;
var listeners = ref.listeners;
return [_c('date-range-picker',{attrs:{"value":_vm.dateValue},on:{"input":function (v) { return listeners.input(v); }}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }